import React, { Component } from "react";
import { connect } from 'react-redux'
import { Table, Tag, Badge } from "antd";
import { showProductModal } from '../../../redux/actions/miscActions'

export class ProductOverview extends Component {

  handleEdit=(product)=>{
    this.props.showProductModal(product)
  }

  render() {
    const { products } = this.props;
    const columns = [
      {
        title: "Beschikbaar",
        width: 120,
        key: "isVisible",
        filters: [
          {
            text: "zichtbaar",
            value: true,
          },
          {
            text: "niet zichtbaar",
            value: false,
          },
        ],
        onFilter: (value, record) => record.isVisible === value,
        render: (text, record) =>
          text.isVisible ? (
            <Tag color="green">zichtbaar</Tag>
          ) : (
            <Tag color="red">niet zichtbaar</Tag>
          ),
      },
      {
        title: "Image",
        dataIndex: "productImage",
        key: "productImage",
        width: 80,
        render: (productImage) => (
          <img src={productImage} alt="" className="table-image" />
        ),
      },
      { title: "Product", dataIndex: "productNaam", key: "productNaam" },
      {
        title: "Prijs",
        dataIndex: "productPrijs",
        key: "productPrijs",
        render: (text, record) => `${new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'SRD'}).format(`${(record.productPrijs)}`)}`,
      },
      {
        title: "On sale",
        key: "productOnSale",
        filters: [
          {
            text: "on sale",
            value: true,
          },
        ],
        onFilter: (value, record) => record.productOnSale === value,
        render: (text, record) =>
          text.productOnSale ? (
            <span>
              <Badge status="success" />
              on sale
            </span>
          ) : (
            "-"
          ),
      },
      {
        title: "Sales prijs",
        dataIndex: "salesPrice",
        key: "salesPrice",
        render: (text, record) =>
          record.productOnSale ? `${new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'SRD'}).format(`${(record.salesPrice)}`)}` : "-",
      },
      {
        title: "Action",
        key: "operation",
        width: 40,
        render: (text, record) => (
          <i
            className="fas fa-pencil-alt"
            onClick={() => this.handleEdit(text, record)}
          ></i>
        ),
      },
    ];

    return (
      <div>
        <Table
          className="products-table"
          columns={columns}
          dataSource={products}
          pagination={{ pageSize: 5 }}
        />
      </div>
    );
  }
}

export default connect(null, {showProductModal})(ProductOverview);
